import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AskVendorComponent } from '@app/shared/components/ask-vendor/ask-vendor.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { AuthenticationService } from '@app/_services';
import { Router } from '@angular/router';
import { NgIf } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
    selector: 'app-block-company-details',
    templateUrl: './block-company-details.component.html',
    styleUrls: ['./block-company-details.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [MatTabsModule, NgIf, TranslateModule]
})
export class BlockCompanyDetailsComponent implements OnInit {

    @Input() companyData;
    @Input() fromLayout = false;
    userDetails = false;
    vendorModalRef: BsModalRef;
    bsModalRef: BsModalRef;
    image = 'assets/images/nologo.png';

    constructor(
        private modalService: BsModalService,
        private authService: AuthenticationService,
        // public bsModalRef: BsModalRef,
        public translate: TranslateService,
        public translateHelper: TranslateHelper
    ) { }

    ngOnInit(): void {
        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
        });
    }


}
